import { atom } from 'recoil'

export const filterState = atom<{ skills: number[]; locations: number[] }>({
  key: 'filterState',
  default: {
    skills: [],
    locations: []
  }
})
